import WorldBorderService from "../world-border/world-border-service";
import BoundaryService from "../boundary/boundary-service";
import StandardDirection from "./standard-direction";
import sprintFactor from "./sprint-factor";

class UserNavigation {
    axes;
    lastValidPosition = null;

    constructor() {
        this.axes = {
            FORWARD: new THREE.Vector3(0, 0, -1),
            BACKWARD: new THREE.Vector3(0, 0, 1),
            LEFT: new THREE.Vector3(-1, 0, 0),
            RIGHT: new THREE.Vector3(1, 0, 0),
            UP: new THREE.Vector3(0, 1, 0),
            DOWN: new THREE.Vector3(0, -1, 0)
        };

        VR.mouseControls.addEventListener("change", e => this.monitorOrbitControl(e));
    }

    move(directionName, isSprint, distanceFactor = 1) {
        const direction = this.axes[directionName];
        const distance = getDistance();
        const lockYMovement = getLockYMovement();
        this.moveOnAxis(direction, distance, lockYMovement);

        function getDistance() {
            const sprintMultiplier = isSprint ? sprintFactor : 1;
            return wv.effectController.MoveSpeed * wv.effectController.StepSize * sprintMultiplier * distanceFactor;
        }

        function getLockYMovement() {
            return !wv.flyMode && directionName !== StandardDirection.DOWN && directionName !== StandardDirection.UP;
        }
    }

    moveOnAxis(axis, distance, lockYMovement) {
        const nextPosition = getNextPosition();
        this.moveTo(nextPosition);

        function getNextPosition() {
            const position = iq3Camera.getConfigurationWorld().position.clone();
            const orientation = iq3Camera.getConfigurationWorld().orientation.clone();
            let result = axis.clone()
                .applyQuaternion(orientation)
                .multiplyScalar(distance)
                .add(position);

            if (lockYMovement) result.setY(position.y);
            return result;
        }
    }

    setHeight(height) {
        const position = iq3Camera.getConfigurationWorld().position.clone();
        position.setY(height);
        this.moveTo(position);
    }

    moveTo(position) {
        WorldBorderService.limitToBorder(position.clone());
        const currentPosition = iq3Camera.getConfigurationWorld().position;

        if (!BoundaryService.isAllowed(currentPosition, position)) {
            console.log("Trying to enter blacklisted area: ", position.clone());
            return;
        }

        iq3Camera.setPosition(position);
        updateUsersPosition();
    }

    monitorOrbitControl(event) {
        const currentPosition = iq3Camera.getConfigurationWorld().position.clone();

        if (!this.lastValidPosition) {
            this.lastValidPosition = currentPosition.clone();
            return;
        }
        
        if (!BoundaryService.isAllowed(this.lastValidPosition, currentPosition)) {
            console.log("Entered blacklisted area: ", currentPosition.clone(), "Moving to boundary edge.");

            const validPosition = BoundaryService.getValidPosition(this.lastValidPosition, currentPosition);
            iq3Camera.setPosition(validPosition);
            this.lastValidPosition = validPosition.clone();
        } else {
            this.lastValidPosition = currentPosition.clone();
        }
    }

    resetLastValidPosition() {
        const currentPosition = iq3Camera.getConfigurationWorld().position.clone();
        this.lastValidPosition = currentPosition.clone();
    }

    monitorVRCamera() {
        //ignore for now
    }
}

export default UserNavigation;
